import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IHrCapitalFormationTierPaginatedResponse,
  getHrCapitalFormationTierPaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { HrCapitalFormationTierModalMode } from "./enums";
import { IHrCapitalFormationTierModalData } from "./types";

const initialState = {
  hrCapitalFormationTierData: null as Nullable<
    IHrCapitalFormationTierPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: HrCapitalFormationTierModalMode.VIEW,
    open: false,
    loading: false,
  } as IHrCapitalFormationTierModalData,
};

export const fetchHrCapitalFormationTierList = createAsyncThunk(
  "hr/fetchHrCapitalFormationTierList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getHrCapitalFormationTierPaginated(filters);
    return response;
  }
);

const hrCapitalFormationTierSlice = createSlice({
  name: "hrCapitalFormationTier",
  initialState,
  reducers: {
    setHrCapitalFormationTierModalData: (
      state,
      action: PayloadAction<IHrCapitalFormationTierModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeHrCapitalFormationTierModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setHrCapitalFormationTierModalLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchHrCapitalFormationTierList.fulfilled,
      (state, action) => {
        if (!action.payload) return;
        return {
          ...state,
          hrCapitalFormationTierData: action.payload
            ?.edges as IHrCapitalFormationTierPaginatedResponse["edges"],
          totalCount: action.payload?.totalCount,
          loading: false,
        };
      }
    );
    builder.addCase(fetchHrCapitalFormationTierList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setHrCapitalFormationTierModalData,
  closeHrCapitalFormationTierModal,
  setHrCapitalFormationTierModalLoading,
} = hrCapitalFormationTierSlice.actions;

export default hrCapitalFormationTierSlice.reducer;
